import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const TabsButton = styled.div<{ active: boolean }>`
  border: ${(props) => (props.active ? '1px solid #131717;' : 'none')};
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* margin-right: 32px; */
  margin-bottom: 24px;
  background-color: transparent;
  border-radius: 200px;
  cursor: pointer;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  line-height: normal;
  ${down('md')} {
    height: 39px;
    margin-right: 5px;
    margin-bottom: 20px;
    white-space: nowrap;
  }
`
export const DiscoverCardElementWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`

export const DiscoverCardCategoryElement = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin: 6px 5px 0 14px;
  [dir='rtl'] && {
    font-size: 16px;
  }
`

export const DiscoverCardTitle = styled.div`
  position: relative;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  margin-left: 6px;
  display: flex;
  background-color: #ffffff;
  color: #131717;
  height: 30px;
  width: fit-content;
  z-index: 2;
  border-radius: 100px;
  gap: '3px';
  justify-content: center;
  align-items: center;
`

export const SliderDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
`
export const DiscoverHeading = styled.h2`
  color: #131717;
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  margin: 40px 0px 24px 0px;

  ${down('md')} {
    margin: 32px 0px 16px 0px;
  }
`
export const DiscoverCard = styled.a`
  position: relative;
  display: flex;
  justify-content: end;
  flex-direction: column;
  width: 100%;
  height: 200px;
  background-color: aliceblue;
  border-radius: 12px;
  background-size: cover;
  overflow: hidden;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50.52%, rgba(0, 0, 0, 0.6) 100%);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`

export const DiscoverCardCategory = styled.div`
  position: absolute;
  bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  padding: 5px 30px;
  border-radius: 12px;
`
